import { inheritActionOwner, isActionCurrent } from '@/_core/fluxstore/dispatchOwnership';
import { useSendCommandAsync } from '@/_core/cqrs/use';
import { RealTimeAction } from '@/_core/fluxstore/types';
import { FlashJustDragged, SetKeyOnNewCard } from '../..';
import { createNewCardCommand } from '../../../api/commands/factory/createNewCard';
import { StorymapState, Subtask } from '../../types';
import { getCardById } from '../../use';
import { useStorymapStore } from '../../useModule';
import { AddNewCardResult } from '../../../api/commands';

const { registerReducer, registerMiddleware, dispatch } = useStorymapStore();

export class SaveNewSubtask extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'SaveNewSubtask';

    public _savedCard: Subtask = null;

    public constructor(public cardId: string, public title?: string, public description?: string) {
        super(SaveNewSubtask.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: SaveNewSubtask): Promise<boolean> => {
    const card = getCardById(action.cardId);
    if (card) {
        card.isSaving = true;
    }

    if (!action.isDispatchedByRealTimeCallback) {
        dispatch(inheritActionOwner(action, new FlashJustDragged()));
    }

    const command = action.isDispatchedByRealTimeCallback ? null : await createNewCardCommand(action);
    if (!isActionCurrent(action)) return false;
    await useSendCommandAsync(action, {
        isCurrent: () => isActionCurrent(action),
        createCommand: async () => command,
        onSuccess: (res: AddNewCardResult) => {
            if (!isActionCurrent(action)) return;
            dispatch(inheritActionOwner(action, new SetKeyOnNewCard(action.cardId, res.CardKey)));
        },
    });

    if (!isActionCurrent(action)) return false;
    if (!action.isDispatchedByRealTimeCallback) {
        action._savedCard = getCardById(action.cardId) as Subtask;
    }

    return true;
};

const reducer = (state: StorymapState, action: SaveNewSubtask): void => {
    if (action.isDispatchedByRealTimeCallback) {
        state.subtasks
            .filter(
                (x) =>
                    x.taskId == action._savedCard.taskId && x.releaseId == action._savedCard.releaseId && x.order >= action._savedCard.order
            )
            .forEach((x) => x.order++);

        state.subtasks.push(action._savedCard);
    }

    const card = getCardById(action.cardId);
    card.title = action.title;
    card.description = action.description;
    card.hasDescription = action.description != null && action.description.trim() != '';
    card.color = state.subtaskColor;
    card.isNew = false;
    card.isSaving = false;

    if (action.isDispatchedByRealTimeCallback) {
        card.isActive = false;
    }

    return;
};

//@ts-ignore
registerMiddleware(SaveNewSubtask.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(SaveNewSubtask.ACTION_TYPE, reducer);
